import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 008
        'numConvocatoria' : 'Convocatoria No. 008/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N18-2026.',
        'vigencia' : '13 al 24 de abril de 2026.',
        'descripcionProcedimiento' : 'Ampliación de módulo del Tribunal Electoral del Estado de Hidalgo, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }8/N18/N18.rar`,
        'start' : '2026-04-13',
        'end' : '2026-04-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 007
        'numConvocatoria' : 'Convocatoria No. 007/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N17-2026.',
        'vigencia' : '6 al 17 de abril de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación punto de venta HIDARTE Pachuca; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }7/N17/N17.rar`,
        'start' : '2026-04-06',
        'end' : '2026-04-17',
        'procedimiento' : 'Licitación Pública',
    },
]